import { EthAddress } from '@xylabs/sdk-js'
import { PropsWithChildren, useContext } from 'react'

import { useEntitySettings } from '../../Hooks'
import { AuthenticationContext } from '../Authentication'
import Context from './Context'

interface Props {
  address?: EthAddress
  enabled?: boolean
}

const Loader: React.FC<PropsWithChildren<Props>> = (props) => {
  const { auth } = useContext(AuthenticationContext)
  const address = props.address
  const settings = useEntitySettings(address, auth?.token)

  return <Context.Provider value={settings}>{props.children}</Context.Provider>
}

export default Loader
